import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DisabledExpressPaymentLiability } from '../../../pay/models/payment.model';
import { DEFAULT_PATTERN } from '../../configs/date-config';

@Component({
standalone: false,
  selector: 'app-disabled-express-payment-dialog',
  templateUrl: './disabled-express-payment-dialog.component.html',
  styleUrls: ['./disabled-express-payment-dialog.component.scss'],
})
export class DisabledExpressPaymentDialogComponent {
  public defaultPattern: string = DEFAULT_PATTERN;

  constructor(
    @Inject(MAT_DIALOG_DATA) public disabledExpressPaymentLiabilities: DisabledExpressPaymentLiability[],
  ) {}

}
